import { ToolbarActionList } from '@abp/ng.components/extensible';
import { eIdentityComponents, IdentityToolbarActionContributors } from '@volo/abp.ng.identity';
import { IdentityUserDto } from '@volo/abp.ng.identity/proxy';

export function removeImportUsersContributor(actionList: ToolbarActionList<IdentityUserDto[]>) {
  const index = actionList.findIndex(
    node => node.value.permission === 'AbpIdentity.Users.Import',
  );

  if (index >= 0) {
    actionList.dropByIndex(index);
  }
}

export const identityToolbarActionContributors: IdentityToolbarActionContributors = {
  [eIdentityComponents.Users]: [removeImportUsersContributor],
};
